import * as React from "react";
import { Button, buttonVariants } from "./base-button";
import type { ButtonProps } from "./base-button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../tooltip";
import { cn } from "../../lib/utils";

export interface ButtonIconProps extends Omit<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  "title"
> {
  title?: React.ReactNode;
}

export const ButtonIcon = React.forwardRef<HTMLButtonElement, ButtonIconProps>(
  ({ className, title, disabled, children, ...props }, ref) => {
    const button = (
      <button
        ref={ref}
        type="button"
        disabled={disabled}
        className={cn(
          "flex h-10 w-10 items-center justify-center rounded-lg bg-transparent",
          "text-gray-700 transition-colors hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50",
          "dark:text-gray-300 dark:hover:bg-gray-700",
          className,
        )}
        {...props}
      >
        {children}
      </button>
    );

    if (!title) {
      return button;
    }

    return (
      <TooltipProvider delayDuration={120}>
        <Tooltip>
          <TooltipTrigger asChild>
            <span className="inline-flex">{button}</span>
          </TooltipTrigger>
          <TooltipContent sideOffset={6}>{title}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  },
);

ButtonIcon.displayName = "ButtonIcon";

export { Button, buttonVariants };
export type { ButtonProps };
